/* Jesus Beads theme behaviour (built on the CouplesBlanket theme).
   Talks to the real Shopify cart. Section HTML is re-rendered server side via
   the Section Rendering API so prices, discounts and currency always come from
   Shopify rather than being recalculated here. */
(function () {
  'use strict';

  var CB = window.CB || {};
  var routes = CB.routes || { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart' };

  /* ---------------- helpers ---------------- */

  /* Prices in product-json arrive already converted to the shopper's currency,
     so a hardcoded dollar sign printed "$35.95" to a shopper in Bulgaria whose
     cart charges EUR 35,95. Shopify also formats each market differently, euro
     as 1.234,56 and forint with no decimals at all, so rather than guessing we
     read the pattern out of a sample the server rendered with the money filter.
     That keeps every figure this script writes identical to the cart, the
     drawer and checkout. */
  var MONEY = (function (sample) {
    sample = String(sample || '');
    var first = sample.search(/\d/);
    if (first < 0) return null;
    var last = sample.length - 1;
    while (last >= 0 && !/\d/.test(sample.charAt(last))) last--;

    var num = sample.slice(first, last + 1);
    var seps = num.replace(/\d/g, '');
    var dec = seps.length ? seps.charAt(seps.length - 1) : '';
    var thou = seps.length > 1 ? seps.charAt(0) : '';
    var frac = dec ? num.split(dec).pop().length : 0;

    /* a lone separator with three digits after it is grouping, not decimals */
    if (frac !== 2) { thou = dec || thou; dec = ''; frac = 0; }

    return {
      prefix: sample.slice(0, first),
      suffix: sample.slice(last + 1),
      dec: dec,
      thou: thou,
      frac: frac
    };
  })(CB.money_sample);

  function formatMoney(cents) {
    if (!MONEY) return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    var neg = cents < 0;
    cents = Math.abs(Math.round(cents));
    var units = MONEY.frac === 2 ? Math.floor(cents / 100) : Math.round(cents / 100);
    var body = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, MONEY.thou);
    if (MONEY.frac === 2) {
      var rem = String(cents % 100);
      body += MONEY.dec + (rem.length < 2 ? '0' + rem : rem);
    }
    return (neg ? '-' : '') + MONEY.prefix + body + MONEY.suffix;
  }

  function money(cents) { return formatMoney(cents); }

  var ACTIVE_CURRENCY =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t || r.status); });
      return r.json();
    });
  }

  /* ---------------- cart drawer ---------------- */

  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');
  var lastFocus = null;
  var announcer = document.getElementById('cart-live');

  function announce(msg) {
    if (!announcer) return;
    announcer.textContent = '';
    setTimeout(function () { announcer.textContent = msg; }, 40);
  }

  function focusables(root) {
    return [].slice.call(root.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('show');
    if (scrim) scrim.classList.add('show');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('locked');
    var c = drawer.querySelector('.dclose');
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('show');
    if (scrim) scrim.classList.remove('show');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (drawer) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('show')) return closeDrawer();
      if (e.key !== 'Tab' || !drawer.classList.contains('show')) return;
      var f = focusables(drawer);
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------------- mobile navigation drawer ---------------- */

  var navdrawer = document.getElementById('navdrawer');
  var navBtn = document.querySelector('[data-open-nav]');

  function openNav() {
    if (!navdrawer) return;
    lastFocus = document.activeElement;
    navdrawer.classList.add('show');
    if (scrim) scrim.classList.add('show');
    navdrawer.setAttribute('aria-hidden', 'false');
    navdrawer.removeAttribute('inert');
    if (navBtn) navBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('locked');
    var c = navdrawer.querySelector('.ndclose');
    if (c) c.focus();
  }
  function closeNav() {
    if (!navdrawer) return;
    navdrawer.classList.remove('show');
    if (scrim) scrim.classList.remove('show');
    navdrawer.setAttribute('aria-hidden', 'true');
    navdrawer.setAttribute('inert', '');
    if (navBtn) navBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function navOpen() { return !!navdrawer && navdrawer.classList.contains('show'); }

  /* One scrim serves both panels, so send it to whichever is actually open. */
  function closeAny() {
    if (navOpen()) return closeNav();
    return closeDrawer();
  }

  if (navBtn) navBtn.addEventListener('click', function (e) { e.preventDefault(); openNav(); });
  if (navdrawer) {
    navdrawer.addEventListener('click', function (e) {
      if (e.target.closest('.ndclose')) { e.preventDefault(); return closeNav(); }
      /* let the link navigate, but shut the panel so a back-swipe does not land on it */
      if (e.target.closest('.ndlinks a')) closeNav();
    });
    document.addEventListener('keydown', function (e) {
      if (!navOpen()) return;
      if (e.key === 'Escape') return closeNav();
      if (e.key !== 'Tab') return;
      var f = focusables(navdrawer);
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (!navdrawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    /* the panel only exists below the nav breakpoint, so do not strand it open */
    window.addEventListener('resize', function () {
      if (navOpen() && window.innerWidth >= 900) closeNav();
    });
  }

  if (scrim) scrim.addEventListener('click', closeAny);
  document.querySelectorAll('[data-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (navOpen()) closeNav();
      refreshCart().then(openDrawer);
    });
  });

  /* Ask Shopify to re-render the drawer snippets so every figure is server-truth. */
  function refreshCart() {
    return fetch(routes.cart + '?section_id=cart-drawer-refresh')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var body = doc.querySelector('[data-cart-body]');
          var foot = doc.querySelector('[data-cart-foot]');
          var title = doc.querySelector('[data-cart-title]');
          if (body) drawer.querySelector('[data-cart-body]').innerHTML = body.innerHTML;
          if (foot) drawer.querySelector('[data-cart-foot]').innerHTML = foot.innerHTML;
          if (title) drawer.querySelector('[data-cart-title]').textContent = title.textContent;
        }
        return fetchJSON(routes.cart + '.js');
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count ? '' : 'none';
        });
        return settleProtection(paintShipping(cart));
      })
      .catch(function () { /* leave the drawer as rendered */ });
  }

  /* ---------------- free shipping bar, across currencies ---------------- */

  /* settings.free_ship_threshold is a shop-currency figure, and it mirrors the
     real Shopify shipping condition, which Shopify also evaluates in shop
     currency. cart.total_price arrives in the presentment currency, so the two
     cannot be compared until the threshold is converted at the market rate.
     Without this the bar reads "$5 from free shipping" in CAD and claims
     "unlocked" in INR on a cart worth a few dollars. */
  function shipTargetCents() {
    var shopCents = +(CB.free_ship || 0);
    if (!shopCents) return 0;
    var cur = (window.Shopify && window.Shopify.currency) || {};
    var rate = parseFloat(cur.rate);
    if (!rate || rate <= 0) rate = 1;
    return Math.round(shopCents * rate);
  }

  function paintShipping(cart) {
    if (!cart || !drawer) return cart;
    var target = shipTargetCents();
    var bar = drawer.querySelector('[data-ship-bar]');
    var line = drawer.querySelector('[data-ship-line]');

    if (bar && target > 0) {
      var remaining = target - cart.total_price;
      var pct = Math.max(0, Math.min(100, Math.round(cart.total_price * 100 / target)));
      var txt = bar.querySelector('[data-ship-text]');
      var fill = bar.querySelector('[data-ship-fill]');
      if (fill) fill.style.width = pct + '%';
      if (txt) {
        txt.textContent = remaining > 0
          ? 'You are ' + formatMoney(remaining) + ' from free shipping'
          : 'Free shipping unlocked';
      }
    }
    if (line) {
      line.textContent = (target > 0 && cart.total_price >= target) ? 'Free' : 'Calculated at checkout';
    }
    return cart;
  }

  /* Shipping Protection is opt out, so it goes in by itself the first time there
     is something to protect. Unchecking it is remembered for the session, which
     is what stops it climbing back in on the next cart change. */
  var DECLINED = 'cb_protection_declined';
  var settling = false;

  function declined() {
    try { return sessionStorage.getItem(DECLINED) === '1'; } catch (e) { return false; }
  }

  function setDeclined(v) {
    try { v ? sessionStorage.setItem(DECLINED, '1') : sessionStorage.removeItem(DECLINED); } catch (e) {}
  }

  function protectionBox() { return drawer ? drawer.querySelector('#protect') : null; }

  function settleProtection(cart) {
    if (settling || !cart) return cart;
    var box = protectionBox();
    if (!box) return cart;
    var id = +box.getAttribute('data-protection-variant');
    if (!id) return cart;

    var others = 0;
    var own = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === id) own = cart.items[i];
      else others += cart.items[i].quantity;
    }

    /* nothing left to protect, so it should not be sitting there on its own */
    if (own && others === 0) {
      settling = true;
      return changeLine(own.key, 0).then(refreshCart).then(done(cart), done(cart));
    }
    if (!own && others > 0 && !declined()) {
      settling = true;
      return addItems([{ id: id, quantity: 1 }]).then(refreshCart).then(done(cart), done(cart));
    }
    return cart;
  }

  function done(fallback) {
    return function (result) { settling = false; return result || fallback; };
  }

  function addItems(items) {
    return fetchJSON(routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  function changeLine(key, qty) {
    return fetchJSON(routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]');
      if (q) {
        e.preventDefault();
        q.disabled = true;
        return changeLine(q.getAttribute('data-qty'), +q.getAttribute('data-to'))
          .then(refreshCart)
          .catch(function () { q.disabled = false; });
      }
      if (e.target.closest('.dclose')) return closeDrawer();
      var x = e.target.closest('#xsell-add');
      if (x) {
        e.preventDefault();
        x.disabled = true;
        return addItems([{ id: +x.getAttribute('data-upsell-variant'), quantity: 1 }])
          .then(refreshCart)
          .catch(function () { x.disabled = false; });
      }
    });

    drawer.addEventListener('change', function (e) {
      var p = e.target.closest('#protect');
      if (!p) return;
      var id = +p.getAttribute('data-protection-variant');
      setDeclined(!p.checked);
      if (p.checked) {
        addItems([{ id: id, quantity: 1 }]).then(refreshCart);
      } else {
        fetchJSON(routes.cart + '.js').then(function (cart) {
          var line = cart.items.filter(function (i) { return i.variant_id === id; })[0];
          if (line) return changeLine(line.key, 0).then(refreshCart);
        });
      }
    });
  }

  /* ---------------- product page ---------------- */

  var buy = document.getElementById('buy');
  if (buy) {
    var productEl = document.getElementById('product-json');
    var product = null;
    try { product = JSON.parse(productEl.textContent); } catch (e) {}

    var form = document.getElementById('product-form');
    var variantInput = buy.querySelector('[data-variant-id]');
    var chosen = [];
    var qty = 1;

    if (product) {
      var startId = +variantInput.value;
      var startVariant = product.variants.filter(function (v) { return v.id === startId; })[0] || product.variants[0];
      chosen = startVariant.options.slice();
    }

    function findVariant() {
      if (!product) return null;
      return product.variants.filter(function (v) {
        for (var i = 0; i < chosen.length; i++) if (v.options[i] !== chosen[i]) return false;
        return true;
      })[0] || null;
    }

    function colorIndex() {
      if (!product) return 0;
      for (var i = 0; i < product.options.length; i++) {
        var n = (product.options[i].name || product.options[i]).toString().toLowerCase();
        if (n.indexOf('color') > -1 || n.indexOf('colour') > -1) return i;
      }
      return 0;
    }

    var colorSlide = document.querySelector('[data-color-slide]');
    var gallery = document.querySelector('[data-gallery="pdp"]');

    function syncGallery(scroll) {
      if (!colorSlide || !product) return;
      var name = (chosen[colorIndex()] || '').toString();
      var key = name.toLowerCase();
      var src = (CB.assets || {})[key];
      var img = colorSlide.querySelector('img');
      if (img && src) {
        img.setAttribute('src', src);
        img.setAttribute('srcset', '');
        img.setAttribute('alt', name + ' ' + (product.title || ''));
      }
      var cap = colorSlide.querySelector('[data-color-caption]');
      if (cap) cap.textContent = name;
      if (scroll && gallery) {
        if (gallery.scrollWidth > gallery.clientWidth + 4) {
          var left = colorSlide.offsetLeft - gallery.offsetLeft - (gallery.clientWidth - colorSlide.clientWidth) / 2;
          gallery.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        } else if (colorSlide.animate) {
          colorSlide.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
        }
      }
    }

    function paint() {
      var v = findVariant();
      var atc = document.getElementById('atc');

      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        return;
      }
      variantInput.value = v.id;
      var qin = form ? form.querySelector('[data-qty-input]') : null;
      if (qin) qin.value = qty;

      var unit = v.price;
      var unitCompare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
      var rate = 1; /* tiers are multiples of the single price, the saving shown is against compare-at */
      var total = Math.round(unit * qty * rate);
      var totalCompare = unitCompare ? unitCompare * qty : 0;

      var now = buy.querySelector('[data-price-now]');
      var was = buy.querySelector('[data-price-was]');
      var off = buy.querySelector('[data-price-off]');
      if (now) now.textContent = money(total);
      if (was) {
        if (totalCompare > total) { was.textContent = money(totalCompare); was.hidden = false; }
        else { was.hidden = true; }
      }
      if (off) {
        if (totalCompare > total) {
          off.textContent = 'SAVE ' + Math.floor((1 - total / totalCompare) * 100) + '%';
          off.hidden = false;
        } else { off.hidden = true; }
      }

      /* Cost per night in the shopper's own money. This used to print a bare
         minor-unit count with the word "cents" hardcoded, which read as "548
         cents a night" to someone shopping in rupees. "Cents" is kept for USD,
         where it is both correct and the stronger line, and only while the
         figure is still under a dollar. */
      var pd = buy.querySelector('[data-perday]');
      if (pd) {
        var perNight = Math.round(unit / 730);
        pd.textContent = 'About ' +
          (ACTIVE_CURRENCY === 'USD' && perNight > 0 && perNight < 100
            ? perNight + ' cents'
            : money(perNight)) +
          ' a night over two years.';
      }

      buy.querySelectorAll('[data-opt]').forEach(function (b) {
        var i = +b.getAttribute('data-opt');
        b.setAttribute('aria-pressed', chosen[i] === b.getAttribute('data-value') ? 'true' : 'false');
      });
      buy.querySelectorAll('[data-color-label]').forEach(function (el) { el.textContent = chosen[colorIndex()] || ''; });

      buy.querySelectorAll('[data-qtytier]').forEach(function (t) {
        var n = +t.getAttribute('data-qtytier');
        t.setAttribute('data-on', n === qty ? '1' : '0');
        var radio = t.querySelector('input[name="bundle"]');
        if (radio) radio.checked = (n === qty);
        var r = 1;
        var tp = Math.round(unit * n * r);
        /* With a compare-at price, strike that. Without one, which is every EU
           and EEA market since Shopify withholds it there, strike what these
           blankets cost bought one at a time at today's price. That is a live
           figure the shopper can check on this page, not a claim about a former
           price, so it survives where a compare-at does not. */
        var tc = unitCompare ? unitCompare * n : Math.round(unit * n);
        var pEl = t.querySelector('[data-tier-price]');
        var cEl = t.querySelector('[data-tier-compare]');
        var sEl = t.querySelector('[data-tier-save]');
        if (pEl) pEl.textContent = money(tp);
        if (cEl) {
          cEl.textContent = tc > tp ? money(tc) : '';
          cEl.style.display = tc > tp ? '' : 'none';
        }
        if (sEl) {
          var saved = tc - tp;
          sEl.textContent = saved > 0 ? 'You save ' + money(saved) : '';
          sEl.style.display = saved > 0 ? '' : 'none';
        }
      });

      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? 'Add to cart · ' + money(total) : 'Sold out';
      }
      var sb = document.querySelector('.sticky');
      if (sb) {
        var sp = sb.querySelector('[data-sticky-price]');
        if (sp) sp.innerHTML = money(total) + (totalCompare > total ? ' <s>' + money(totalCompare) + '</s>' : '');
      }
    }

    buy.addEventListener('click', function (e) {
      var o = e.target.closest('[data-opt]');
      if (o) {
        chosen[+o.getAttribute('data-opt')] = o.getAttribute('data-value');
        paint();
        if (o.hasAttribute('data-color')) syncGallery(true);
      }
    });

    buy.addEventListener('change', function (e) {
      var r = e.target.closest('input[name="bundle"]');
      if (r) { qty = +r.value; paint(); }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = findVariant();
        if (!v || !v.available) return;
        var items = [{ id: v.id, quantity: qty }];
        var up = document.getElementById('upsell-check');
        if (up && up.checked && up.getAttribute('data-upsell-variant')) {
          items.push({ id: +up.getAttribute('data-upsell-variant'), quantity: 1 });
        }
        /* Shipping Protection is chosen here, beside the bead pack. Unticking it
           is remembered for the session so the drawer does not put it back. */
        var pr = document.getElementById('protect-check');
        var pid = pr ? +pr.getAttribute('data-protection-variant') : 0;
        if (pr) setDeclined(!pr.checked);
        var atc = document.getElementById('atc');
        if (atc) atc.disabled = true;
        /* Straight to checkout. The cart drawer is only used when the shopper
           opens it from the header. */
        fetchJSON(routes.cart + '.js')
          .then(function (cart) {
            var already = cart.items.some(function (i) { return i.variant_id === pid; });
            if (pr && pr.checked && pid && !already) items.push({ id: pid, quantity: 1 });
            return addItems(items);
          })
          .then(function () { return fetchJSON(routes.cart + '.js'); })
          .then(settleProtection)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            alert('Could not add to cart. ' + err.message);
            if (atc) atc.disabled = false;
          });
      });
    }

    var sticky = document.querySelector('.sticky');
    if (sticky) {
      sticky.addEventListener('click', function (e) {
        if (e.target.closest('button') && form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      var atcEl = document.getElementById('atc');
      if (atcEl && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0);
          });
        }, { threshold: 0 }).observe(atcEl);
      }
    }

    paint();
    syncGallery(false);
  }

  /* ---------------- gallery dots ---------------- */

  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var dots = document.querySelector('[data-dots="' + gal.getAttribute('data-gallery') + '"]');
    if (!dots) return;
    var figs = gal.querySelectorAll('figure');
    if (!figs.length) return;
    function sync() {
      var i = Math.round(gal.scrollLeft / (gal.scrollWidth / figs.length));
      dots.querySelectorAll('button').forEach(function (b, n) {
        b.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }
    gal.addEventListener('scroll', function () {
      window.clearTimeout(gal._t); gal._t = window.setTimeout(sync, 60);
    }, { passive: true });
    dots.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var n = [].indexOf.call(dots.querySelectorAll('button'), b);
      gal.scrollTo({ left: figs[n].offsetLeft - gal.offsetLeft, behavior: 'smooth' });
    });
    sync();
  });

  /* ---------------- before / after reveal ---------------- */

  document.querySelectorAll('.reveal').forEach(function (r) {
    var range = r.querySelector('input[type=range]');
    var over = r.querySelector('.over');
    var handle = r.querySelector('.handle');
    var knob = r.querySelector('.knob');
    if (!range || !over) return;
    function draw() {
      var v = +range.value;
      over.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      if (handle) handle.style.left = v + '%';
      if (knob) knob.style.left = v + '%';
    }
    range.addEventListener('input', draw);
    draw();
  });

  /* ---------------- track order lookup ---------------- */

  var tform = document.getElementById('track-form');
  if (tform) {
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    function setErr(field, msg) {
      field.setAttribute('aria-invalid', 'true');
      var id = field.id + '-err';
      var el = document.getElementById(id);
      if (!el) {
        el = document.createElement('span');
        el.className = 'field-error'; el.id = id; el.setAttribute('role', 'alert');
        field.insertAdjacentElement('afterend', el);
      }
      el.textContent = msg;
    }
    function clearErr(field) {
      field.removeAttribute('aria-invalid');
      var el = document.getElementById(field.id + '-err');
      if (el) el.remove();
    }
    var no = document.getElementById('order-no');
    var em = document.getElementById('track-email');
    [no, em].forEach(function (f) {
      if (f) f.addEventListener('input', function () { if (f.getAttribute('aria-invalid')) clearErr(f); });
    });
    tform.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = null;
      if (!no.value.trim() || !/^CB-?\d{3,8}$/i.test(no.value.trim())) {
        setErr(no, 'That does not look like an order number. The format is CB-10428.'); bad = bad || no;
      } else clearErr(no);
      if (!em.value.trim() || !EMAIL.test(em.value.trim())) {
        setErr(em, 'Enter the email you used at checkout.'); bad = bad || em;
      } else clearErr(em);
      var res = document.getElementById('track-result');
      if (bad) { bad.focus(); if (res) res.classList.remove('show'); return; }
      var echo = document.getElementById('track-echo');
      if (echo) echo.textContent = no.value.trim().toUpperCase();
      if (res) { res.classList.add('show'); res.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
    });
  }
})();
